import React, { createContext, useState } from "react";

import { Box, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Navigation from "../../components/Navigation/Navigation";
import Container from "../../components/Container";
import HospitalDropdownMenu from "./components/HospitalDropdownMenu";
import RodaTabs from "./components/RodaTabs";
import { HospitalsContextType } from "./types";
import { appVersion } from "../../constants/version";
import MetaDecorator from "../../components/MetaDecorator";

const useStyles = makeStyles(() =>
  createStyles({
    bottom: {
      position: "fixed",
      bottom: "2px",
      right: "4px",
      float: "right",
      opacity: 0.5,
    },
  })
);

export const HospitalsContext = createContext<HospitalsContextType>({
  currentHospital: 0,
  setCurrentHospital: () => {},
  error: false,
  setError: () => {},
});

export default function RodaHomepage() {
  const classes = useStyles();
  const [currentHospital, setCurrentHospital] = useState<number>(0);
  const [error, setError] = useState<boolean>(false);

  return (
    <>
      <MetaDecorator />
      <Navigation />
      <Box pb={8} pt={7}>
        <Container maxWidth="lg">
          <HospitalsContext.Provider
            value={{
              currentHospital,
              setCurrentHospital,
              error,
              setError,
            }}
          >
            <HospitalDropdownMenu />
            <RodaTabs />
          </HospitalsContext.Provider>
        </Container>
        <Typography className={classes.bottom}>{appVersion}</Typography>
      </Box>
    </>
  );
}
